@if (widget$ | async; as widget) {
  <igo-widget-outlet
    [widget]="widget"
    [inputs]="widgetInputs$ | async"
    [subscribers]="widgetSubscribers$ | async"
    (cancel)="onWidgetCancel(widget)"
    (complete)="onWidgetComplete(widget)"
  />
}
